export const PageHeader = ({ title, subtitle, actions, testId }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8" data-testid={testId || "page-header"}>
    <div>
      <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
        {title}
      </h1>
      {subtitle && <p className="mt-2 text-slate-500 max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
  </div>
);

export default PageHeader;
